import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import router from '~/router'
import { setupI18n } from '~/i18n'

import App from './App.vue'

import '~/assets/main.css'

const head = createHead()
const app = createApp(App)

// Setup i18n
setupI18n(app)

app.use(router)
app.use(head)
app.mount('#app')
